import { useState } from "react";
import Card from "../../../components/base/Card";
import { useNavigate } from "react-router-dom";
// Images
import Rendering1 from "@/assets/images/3D/3d.png";
import LightingCoverageImg from "@/assets/images/lighting/lighting_cover.png";
import WifiCardImg from "@/assets/images/wifi/wifi.png";
import FlooPlan1 from "@/assets/images/floorplan/1.png";
import Lighting1 from "@/assets/images/lighting/Lighting.png";
import LineDiagram2 from "@/assets/images/linediagram/2.png";

export default function ServicesSection() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("drafting");

  // --- Original Data (Drafting) ---
  const draftingServices = [
    {
      title: "Architectural Site Plans",
      description:
        "Detailed architectural floor plans with accurate dimensions, furniture layouts, space optimization, and code compliance for residential and commercial projects.",
      image: FlooPlan1,
      features: [
        "Space Planning",
        "Furniture Layouts",
        "Code Compliance",
        "Dimension Accuracy",
      ],
    },
    {
      title: "Architectural Floor Plans",
      description:
        "Detailed architectural floor plans with accurate dimensions, furniture layouts, space optimization, and code compliance for residential and commercial projects.",
      image: FlooPlan1,
      features: [
        "Space Planning",
        "Furniture Layouts",
        "Code Compliance",
        "Dimension Accuracy",
      ],
    },
    {
      title: "Architectral Elevations/Section Plans",
      description:
        "Detailed architectural floor plans with accurate dimensions, furniture layouts, space optimization, and code compliance for residential and commercial projects.",
      image: FlooPlan1,
      features: [
        "Space Planning",
        "Furniture Layouts",
        "Code Compliance",
        "Dimension Accuracy",
      ],
    },
     {
      title: "RCP Plans",
      description:
        "Detailed architectural floor plans with accurate dimensions, furniture layouts, space optimization, and code compliance for residential and commercial projects.",
      image: FlooPlan1,
      features: [
        "Space Planning",
        "Furniture Layouts",
        "Code Compliance",
        "Dimension Accuracy",
      ],
    },
     {
      title: "3D Photorealistic Renderings",
      description:
        "Professional lighting design and analysis using industry-standard Dialux software for optimal illumination and energy efficiency in all spaces.",
      image: Rendering1,
      features: [
        "Lighting Analysis",
        "Energy Efficiency",
        "Photometric Calculations",
        "Code Compliance",
      ],
    },
    {
      title: "Line Diagrams",
      description:
        "Technical line diagrams, electrical schematics, and system layouts for engineering projects with precise documentation and industry standards.",
      image: LineDiagram2,
      features: [
        "Electrical Schematics",
        "System Layouts",
        "Technical Documentation",
        "Industry Standards",
      ],
    },
    {
      title: "Lighting Design & Analysis",
      description:
        "Precise 2D and 3D technical drawings, floor plans, and detailed engineering schematics for all project types with industry-standard accuracy.",
      image: Lighting1,
      features: [
        "2D Technical Drawings",
        "3D Modeling",
        "Engineering Schematics",
        "Precision Documentation",
      ],
    },
    {
      title: "Wifi Coverage",
      description:
        "Advanced Building Information Modeling (BIM) with photorealistic 3D renderings and parametric design capabilities for complex architectural projects.",
      image: WifiCardImg,
      features: ["BIM Modeling", "Photorealistic Renderings"],
    },
    {
      title: "Lighting Coverage",
      description: "photorealistic 3D renderings for Lighting",
      image: LightingCoverageImg,
      features: [
        "BIM Modeling",
        "Photorealistic Renderings",
        "Parametric Design",
        "Collaboration Tools",
      ],
    },
    {
      title: "Programming Schedule Drawingss",
      description: "photorealistic 3D renderings for Lighting",
      image: LightingCoverageImg,
      features: [
        "BIM Modeling",
        "Photorealistic Renderings",
        "Parametric Design",
        "Collaboration Tools",
      ],
    },
    
  ];

  // --- New Data (Takeoff) ---
  // Note: I have reused existing images as placeholders. 
  // You should import specific takeoff images and replace them here.
  const takeoffServices = [
    {
      title: "Proposal Building",
      description:
        "Comprehensive material lists derived from blueprints, ensuring accurate ordering for lumber, concrete, steel, and finishing materials.",
      image: FlooPlan1, // Placeholder
      features: [
        "Lumber & Framing",
        "Concrete & Masonry",
        "Drywall & Insulation",
        "Waste Factor Analysis",
      ],
    },
    {
      title: "Cost Estimation",
      description:
        "Detailed cost analysis and budget preparation helping contractors and developers understand project financial requirements before construction begins.",
      image: LineDiagram2, // Placeholder
      features: [
        "Budget Preparation",
        "Labor Costing",
        "Bid Estimates",
        "Project Feasibility",
      ],
    },
    {
      title: "System Design",
      description:
        "Specialized quantity surveying for Mechanical, Electrical, and Plumbing systems, ensuring accurate component counts and system length measurements.",
      image: Lighting1, // Placeholder
      features: [
        "Ductwork Quantification",
        "Electrical Fixture Counts",
        "Piping Lengths",
        "System Components",
      ],
    },
    {
      title: "Flooring & Finishes",
      description:
        "Exact area calculations for flooring, tiling, painting, and wall coverings to minimize waste and optimize procurement strategies.",
      image: Rendering1, // Placeholder
      features: [
        "Surface Area calc",
        "Tile Count",
        "Paint Volume",
        "Finish Schedules",
      ],
    },
  ];

  // Determine which list to show
  const currentServices = activeTab === "drafting" ? draftingServices : takeoffServices;

  return (
    <section id="services" className="py-20 bg-[#dbcfbf]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-[#212026] mb-4">
            Our Services
          </h2>
          <p className="text-xl text-[#889d8f] max-w-3xl mx-auto mb-8">
            Comprehensive engineering, drafting, and estimation solutions using
            industry-leading methodologies.
          </p>

          {/* --- Toggle Switch --- */}
          <div className="flex justify-center">
            <div className="bg-white dark:bg-slate-800 p-1.5 rounded-full shadow-lg inline-flex relative z-10">
              <button
                onClick={() => setActiveTab("drafting")}
                className={`px-6 md:px-8 py-3 rounded-full text-sm md:text-base font-bold transition-all duration-300 ${
                  activeTab === "drafting"
                    ? "bg-[#F5A623] text-white shadow-md"
                    : "text-gray-500 hover:text-[#F5A623] dark:text-gray-400"
                }`}
              >
                Drafting Services
              </button>
              <button
                onClick={() => setActiveTab("takeoff")}
                className={`px-6 md:px-8 py-3 rounded-full text-sm md:text-base font-bold transition-all duration-300 ${
                  activeTab === "takeoff"
                    ? "bg-[#F5A623] text-white shadow-md"
                    : "text-gray-500 hover:text-[#F5A623] dark:text-gray-400"
                }`}
              >
                Takeoff Services
              </button>
            </div>
          </div>
        </div>

        <section className="py-10 dark:bg-slate-900 transition-colors duration-300 min-h-[600px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentServices.map((service, index) => (
              <div key={`${activeTab}-${index}`} className="perspective-1000 h-[400px]">
                <div className="relative w-full h-full transition-transform duration-700 transform-style-3d group hover:[transform:rotateY(180deg)]">
                  {/* Front of card */}
                  <div className="absolute inset-0 backface-hidden">
                    <Card className="h-full overflow-hidden dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300">
                      <div className="relative h-full bg-[#dbcfbf]/10 dark:bg-slate-700/30">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-full object-cover object-top"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                          <h3 className="text-2xl font-bold text-white">
                            {service.title}
                          </h3>
                        </div>
                      </div>
                    </Card>
                  </div>

                  {/* Back of card */}
                  <div className="absolute inset-0 backface-hidden [transform:rotateY(180deg)]">
                    <Card className="h-full overflow-hidden dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300">
                      <div className="p-6 h-full flex flex-col justify-between">
                        <div>
                          <h3 className="text-xl font-bold text-[#F5A623] dark:text-[#F5A623] mb-3">
                            {service.title}
                          </h3>
                          <p className="text-[#889d8f] dark:text-gray-300 mb-4 leading-relaxed text-sm transition-colors duration-300">
                            {service.description}
                          </p>
                        </div>
                        <div>
                          <div className="flex flex-wrap gap-2">
                            {service.features.map((feature, idx) => (
                              <span
                                key={idx}
                                className="text-xs px-2 py-1 bg-[#dbcfbf]/50 dark:bg-slate-700/50 text-[#212026] dark:text-gray-300 rounded-full transition-colors duration-300"
                              >
                                {feature}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      <style>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .transform-style-3d {
          transform-style: preserve-3d;
        }
        .backface-hidden {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }
      `}</style>
    </section>
  );
}